import { analytics } from '@wlb/shared/analytics';
import {
  APP_ENV,
  GA4_MEASUREMENT_ID,
  IS_DEV,
} from '@wlb/shared/config/env';
import {
  resolveAnalyticsRoute,
  sanitizeAnalyticsReferrer,
} from './analyticsRoutes';

let initialization: Promise<void> | null = null;

/** Initialize the fail-safe GA4 web adapter once per application load. */
export const initializeGoogleAnalytics = (): Promise<void> => {
  if (!initialization) {
    initialization = analytics.init({
      // Native SDK fields are required by the shared interface but unused on web.
      posthogApiKey: '',
      posthogHost: '',
      appsFlyerDevKey: '',
      appsFlyerAppId: '',
      ga4MeasurementId: GA4_MEASUREMENT_ID,
      appEnv: APP_ENV,
      isDebug: IS_DEV,
      initialPagePath:
        typeof window === 'undefined'
          ? '/'
          : resolveAnalyticsRoute(window.location.pathname).pagePath,
      initialPageReferrer:
        typeof window === 'undefined' || typeof document === 'undefined'
          ? ''
          : sanitizeAnalyticsReferrer(
              document.referrer,
              window.location.origin,
            ),
    });
  }
  return initialization;
};
